import baguetteBox from 'baguettebox.js';
import OrderForm from './components/order-form';

document.addEventListener('DOMContentLoaded', () => {
  baguetteBox.run('.event-detail-poster', {
    async: true,
    animation: 'fadeIn',
    captions: false,
    buttons: false,
    noScrollbars: true,
  });

  new OrderForm();
});



// WEBPACK FOOTER //
// ./scripts/akce.js